import { AfterViewInit, Component, ViewChild } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { DialogComponent } from "src/app/components";

@Component({
  selector: 'export-products-labels-dialog',
  host: { 'class': 'dialog' },
  templateUrl: './export-products-labels.dialog.html'
})
export class ExportProductsLabelsDialog {
  @ViewChild('dialog', { static: true, read: DialogComponent })
  private _dialog: DialogComponent;

  constructor(
    public dialogRef: MatDialogRef<ExportProductsLabelsDialog>) {
  }

  public ngAfterViewInit(): void {
    this._dialog.dataLoaded$
      .subscribe(state => {
        if (!state) {
          return;
        }

        this._dialog.closeDialog();
      });
  }
}